import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { object, string, bool, any } from 'prop-types';

/**
 for image pass properties like this :-
    imageOthers={{
        alt:"altImageName",
        className: "mainMenuIcon",
        width: "24px",
        height: "24px"
      }}
 **/

const Anchor = ({
  title,
  icon,
  className,
  others,
  imageOthers,
  focus,
  isAccessByUPDownKey
}) => {
  const ref = useRef(null);

  useEffect(() => {
    focus && !_.isEmpty(ref.current) && ref.current.focus();
  }, [focus]);

  let tabIndexValue = {
    ...(isAccessByUPDownKey ? { tabIndex: focus ? 0 : -1 } : { tabIndex: '0' })
  };
  const handleKeydownEvent = e => {
    if (e.key === 'Enter') {
      !_.isEmpty(ref.current) && ref.current.click();
    }
  };
  return (
    <a
      className={className}
      {...others}
      ref={ref}
      {...tabIndexValue}
      onKeyDown={handleKeydownEvent}
    >
      {!_.isEmpty(icon) && (
        <img src={`/content/images/${icon}`} alt="" {...imageOthers} />
      )}
      {title}
    </a>
  );
};

Anchor.propTypes = {
  title: string,
  icon: string,
  className: string,
  others: object,
  imageOthers: object,
  focus: any,
  isAccessByUPDownKey: bool
};

Anchor.defaultProps = {
  title: '',
  icon: '',
  className: '',
  others: {},
  imageOthers: {},
  focus: false,
  isAccessByUPDownKey: false
};
export default Anchor;
